import React, {FC, useEffect} from 'react';
import {BottomBar, Button, Header, ScrollView} from "$uikit";
import {Attachments} from "$shared/components";
import {useRoute} from "react-router5";
import {hideModal} from "$navigation/helper";
import {useSelector} from "react-redux";
import {authSelector} from "$store/auth";


export const PromoCodeContent: FC = () => {
  const { route, router } = useRoute();
  const { isLogged } = useSelector(authSelector);
  const content = route.meta?.options.content;
  useEffect(() => {
    if (!content) {
      hideModal();
    }
  }, [content]);

  return (
    <>
      <Header showCloseButton>Gift content</Header>
      <ScrollView>
        <Attachments
          attachments={content}
          parentObject={`promo_code`}
          decryptKey={''}
        />
      </ScrollView>
      <BottomBar>
        {!isLogged ? (
          <Button stretched>Зарегистрироватся</Button>
        ) : (
          <Button stretched>Смотреть все покупки</Button>
        )}
      </BottomBar>
    </>

  )
}